var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.worker ? _c('view-card', {
    attrs: {
      "title": "담당자 소개"
    }
  }, [_c('data-list', {
    attrs: {
      "dataList": _vm.dataList
    }
  })], 1) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }